angular
	.module('AutoPrequal')
	.controller('applicantContactCtrl', applicantContactCtrl);

applicantContactCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory'];

function applicantContactCtrl($scope, $rootScope, ScrollFactory, DataFactory) {

	$rootScope.progressCurrent = 2;
	$rootScope.progressMobCurrent = 2;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.applicantContact;

	$scope.data = DataFactory.appData.applicant;

	$scope.$watch('data.apPhoneFormatted', function (newVal, oldVal) {
		if (newVal && newVal !== oldVal) {
			$scope.data.apPhone = newVal.replace(/-/g, "").replace(/ /g, "");
		}
	});

	$rootScope.applicantContactNextStep = function () {
		if ($scope.Contact.$valid) {

			DataFactory.appData.applicant.appState.applicantContact = true;

			$scope.data.apPhone = $scope.data.apPhoneFormatted.replace(/-/g, "").replace(/ /g, "");

            DataFactory.setData($scope.data);

            ScrollFactory.showStep("applicantAddress");
			ScrollFactory.goToStep("applicantAddress");
			return true;
		}
		else {
			angular.forEach($scope.Contact.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("applicantName");
        ScrollFactory.goToStep("applicantName");
	}
}
